import {  Box } from "@mui/material";
import { styled as muiStyled } from "@mui/system";
import { Typography } from "@mui/material";

// ==== Estilos do Carrossel Feito com Código ====
export const CarouselContainer = muiStyled(Box)(({ theme }) => ({
    width: "100%",
    maxWidth: "1145px",
    margin: "2rem auto",
    overflow: "hidden",
    position: "relative",

    [theme.breakpoints.down("sm")]: {
        width: "calc(100% - 32px)",
        maxWidth: "388px",
        margin: "1rem auto 1rem auto",
    },
}));

// dragOffset: deslocamento em px enquanto o usuário arrasta (swipe) o carrossel
export const SliderWrapper = muiStyled(Box, {
    shouldForwardProp: (prop) => !["index", "dragOffset", "dragging"].includes(prop),
})(({ index, dragOffset = 0, dragging }) => ({
    display: "flex",
    width: "100%",
    // height: "364px",
    transform: `translateX(calc(-${index * 100}% - ${dragOffset}px))`,
    transition: dragging ? "none" : "transform 0.6s ease-in-out",
    // Mantém a rolagem vertical da página com o dedo sobre o banner
    touchAction: "pan-y",
}));

export const Slide = muiStyled(Box)({
    minWidth: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

});

export const DotContainer = muiStyled(Box)({
    // marginTop: "8px",
    display: "flex",
    justifyContent: "center",
    gap: "8px",
});

export const Dot = muiStyled("span")(({ active }) => ({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: active ? "#7FA7F7" : "#D0DDF7",
    cursor: "pointer",
    transition: "all 0.3s ease",
}));

// ==== Banner  ====
export const BannerContainer = muiStyled(Box)(({ theme }) => ({
    width: "100%",
    height: "290px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1.6rem",
    borderRadius: "24px",
    // borderRadius: "16px",
    backgroundColor: "var(--c-brand-deep)",
    color: "#fff",
    position: "relative",
    overflow: "hidden",
    [`@media (min-width: 901px) and (max-width: 1024px)`]: {
        height: "277px", 
        padding: "1rem 2rem",
        margin: "0 1rem",
    },

    [theme.breakpoints.down("md")]: {
        flexDirection: "row", 
        padding: "1rem",
        height: "220px",
        margin: "0 1rem",
    },
    [theme.breakpoints.down("sm")]: {
        flexDirection: "row",
        height: "auto",
        borderRadius: "12px",
        margin: "0 0.5rem",
        // padding: "0.5rem",
    },
}));

export const BannerText = muiStyled(Box)(({ theme }) => ({
    maxWidth: "500px",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    minHeight: "150px",
    fontFamily: "Lato, sans-serif !important" ,
    fontWeight: "bold",
     "& *": { 
    fontFamily: "Lato, sans-serif"
    }, 
    [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
        fontSize: "14px",
        gap: "0.5rem",
    },
}));

export const CashbackBadge = muiStyled(Box)(({theme}) => ({
    backgroundColor: "#FFD700",
    color: "#000",
    padding: "0.3rem",
    borderRadius: "20px",
    fontWeight: "bold",
    fontSize: "0.9rem",
    display: "inline-block",
    marginBottom: "1rem",
    width: "150px",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
        marginBottom: "0.5rem",
    },
}));

export const BannerImageWrapper = muiStyled(Box)(({ theme }) => ({
    position: "absolute",
    right: "7rem",
    top: "50%",
    transform: "translateY(-50%)",
    maxWidth: "500px" ,
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
        position: "relative",
        marginTop: "0rem",
        bottom: "-98px",
        right: "-8px",
    },
    [theme.breakpoints.down("sm")]: {
        maxWidth: "300px" ,
        width: "70%",
        position: "relative",
        marginTop: "1rem",
        bottom: "-50px",
        right: "-8px",
    },
}));

export const SectionContainer = muiStyled(Box)(({ theme }) => ({
    textAlign: "center",
    margin: "3rem auto 1rem auto",
    maxWidth: "900px",
    padding: "0 1rem",
    fontFamily: "Lato , sans-serif !important" ,

    [theme.breakpoints.down("sm")]: {
        margin: "1rem auto 0rem auto",
    },
}));

export const Title = muiStyled(Typography)(({ theme }) => ({
    fontWeight: 600,
    color: "var(--c-brand-accent)", 
    marginBottom: "0.5rem",
    [theme.breakpoints.down("sm")]: {
        fontSize: "28px",
    },
}));

export const Subtitle = muiStyled(Typography)(({ theme }) => ({
    fontWeight: 400,
    color: "var(--c-brand-accent)",
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));